module.exports = __webpack_public_path__ + "static/media/graph-3.54ac147b.svg";